import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import userDefaultPerfil from "../../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../../redux/auth/actions";
import { withRouter } from "react-router";

const SidebarCapacitacion = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userN = useSelector((store) => store.auth.name);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);
  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };
  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <div className="d-block d-sm-block d-md-none">
              <SubMenu
                title={userN ? userN : null}
                icon={
                  <img
                    src={!!userPic ? userPic : userDefaultPerfil}
                    className="user-pic"
                    alt="Imagen de perfil"
                  />
                }
              >
                <MenuItem>
                  <Link to={`/perfil-usuario/${userId}/${userType}`}>
                    Mi perfil
                  </Link>
                </MenuItem>
                {/* <MenuItem><Link to="Dashboard-Headcount">Dashboard</Link></MenuItem> */}
                {/* <MenuItem style={{ borderBottom: "2px solid white" }}>
                  <Link to={`/perfil-usuario/${userId}`}>Mi perfil</Link>
                </MenuItem> */}
                <div className="row no-gutters"></div>
                <MenuItem
                  icon={<i className="material-icons">notifications</i>}
                >
                  <Link to="/#!">Notificaciones</Link>
                </MenuItem>
                <MenuItem onClick={onSignOut}>Cerrar sesión</MenuItem>
              </SubMenu>
            </div>
            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">business</i>}>
              <Link to={`/capacitacion-desarrollo/empresas-presupuesto`}>
                Empresas presupuesto
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">assignment</i>}>
              <Link to={`/capacitacion-desarrollo/formulario-dnc`}>
                Formulario DNC
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">percent</i>}>
              <Link to={`/capacitacion-desarrollo/meta-por-anio`}>
                Meta por año
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">widgets</i>}>
              <Link to={`/capacitacion-desarrollo/modalidades`}>
                Modalidades
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">type_specimen</i>}>
              <Link to={`/capacitacion-desarrollo/tipo-capacitacion`}>
                Tipo de capacitación
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">restart_alt</i>}>
              <Link to={`/capacitacion-desarrollo/origines`}>Orígenes</Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">web_asset_off</i>}>
              <Link to={`/capacitacion-desarrollo/motivos-inasistencia`}>
                Motivos de inasistencia
              </Link>
            </MenuItem>
            {/* <MenuItem icon={<i className="material-icons">pending</i>}>
              <Link to={`/capacitacion-desarrollo/estados`}>Estados</Link>
            </MenuItem> */}
            <MenuItem icon={<i className="material-icons">co_present</i>}>
              <Link to={`/capacitacion-desarrollo/capacitaciones`}>
                Competencias
              </Link>
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">center_focus_strong</i>}
            >
              <Link to={`/capacitacion-desarrollo/enfoques`}>Enfoques</Link>
            </MenuItem>

            {/* <SubMenu
              title="Métricas"
              icon={<i className="material-icons">analytics</i>}
            >
              <MenuItem>
                <Link to="/capacitacion-desarrollo/metrica-evaluacion-factor">
                  De evaluación por factor
                </Link>
              </MenuItem>
            </SubMenu> */}
            <SubMenu
              title="Factores de evaluación"
              icon={<i className="material-icons">percent</i>}
            >
              <MenuItem>
                <Link to="/capacitacion-desarrollo/metrica-evaluacion-factor">
                  Metrica de evaluación por factor
                </Link>
              </MenuItem>
            </SubMenu>

            {/* <SubMenu
              title="Matriz de 9 cajas"
              icon={<i className="material-icons">inventory_2</i>}
            >
              <MenuItem>
                <Link to="/capacitacion-desarrollo/matriz">Matriz</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/capacitacion-desarrollo/educacion-formal-metricas">
                  Métricas de educación formal
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/capacitacion-desarrollo/metrica-nueve-cajas">
                  Metrica de 9 cajas
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/capacitacion-desarrollo/metrica-experiencia-en-puesto">
                  Metrica de experiencia en puesto
                </Link>
              </MenuItem>
            </SubMenu> */}
            {/* <MenuItem icon={<i className="material-icons">campaign</i>}>
              <Link to={`/capacitacion-desarrollo/rutas-capacitacion`}>
                Campañas de capactitación
              </Link>
            </MenuItem> */}
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </>
  );
};

export default withRouter(SidebarCapacitacion);
